export default __webpack_public_path__ + "static/media/logoBlue.e562354c.png";